export default __webpack_public_path__ + "63ae3e28a2a9cacfd75cc843aa645954.png";